import * as Functions from '../../functions';


export const DateFunctionMap = {


    DATE_ADD_SECOND: { // 即将被 TIME_ADD_SECOND 代替
        name: 'DATE_ADD_SECOND',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Time']
    },
    DATE_ADD_MINUTE: { // 即将被 TIME_ADD_MINUTE 代替
        name: 'DATE_ADD_MINUTE',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Time']
    },
    DATE_ADD_HOUR: { // 即将被 TIME_ADD_HOUR 代替
        name: 'DATE_ADD_HOUR',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Time']
    },


    TIME_ADD_SECOND: {
        name: 'TIME_ADD_SECOND',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Time']
    },
    TIME_ADD_MINUTE: {
        name: 'TIME_ADD_MINUTE',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Time']
    },
    TIME_ADD_HOUR: {
        name: 'TIME_ADD_HOUR',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Time']
    },
    DATE_ADD_DAY: {
        name: 'DATE_ADD_DAY',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Date']
    },
    DATE_ADD_MONTH: {
        name: 'DATE_ADD_MONTH',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Date']
    },
    DATE_ADD_YEAR: {
        name: 'DATE_ADD_YEAR',
        function: Functions.DATE_ADD,
        argumentTypes: ['DateTime', 'Date']
    },


    WEEK_OF_YEAR: {
        name: 'WEEK_OF_YEAR',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },


    YEAR: { // 即将被 YEAR_NUMBER 代替
        name: 'YEAR',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },
    YEAR_NUMBER: {
        name: 'YEAR_NUMBER',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },


    QUARTER: { // 即将被 QUARTER_NUMBER 代替
        name: 'QUARTER',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },
    QUARTER_NUMBER: {
        name: 'QUARTER_NUMBER',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },


    MONTH: { // 即将被 MONTH_NUMBER 代替
        name: 'MONTH',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },
    MONTH_NUMBER: {
        name: 'MONTH_NUMBER',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },


    DAY_OF_WEEK: {
        name: 'DAY_OF_WEEK',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },


    DAY: { // 即将被 DAY_NUMBER 代替
        name: 'DAY',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },
    DAY_NUMBER: {
        name: 'DAY_NUMBER',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    },


    HOUR: { // 即将被 HOUR_NUMBER 代替
        name: 'HOUR',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Time']
    },
    HOUR_NUMBER: {
        name: 'HOUR_NUMBER',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Time']
    },


    MINUTE: { // 即将被 MINUTE_NUMBER 代替
        name: 'MINUTE',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Time']
    },
    MINUTE_NUMBER: {
        name: 'MINUTE_NUMBER',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Time']
    },


    // ALIGNED_WEEK_OF_MONTH: {
    //     name: 'ALIGNED_WEEK_OF_MONTH',
    //     function: Functions.DATE_FETCH,
    //     argumentTypes: ['DateTime', 'Date']
    // },
    ALIGNED_WEEK_OF_YEAR: {
        name: 'ALIGNED_WEEK_OF_YEAR',
        function: Functions.DATE_FETCH,
        argumentTypes: ['DateTime', 'Date']
    }
};
